import { Form, Input, Radio, Select, Switch } from 'antd';
import { useEffect, useState } from 'react';
import { DatePicker } from 'antd';

export const SearchBar = ({ onFinish,type="",serialvalue,disabled, isbarCode=false, inputRef,onPaste = () => {}, getSearchByValue, onFinishFailed, searchItems, onChange, ecomRequest, activeIndex, setSearchShow, setCurrentPage, isTestOrder, isFilter, setfilterObj, showisFilter, setshowisFilter, iscancel, cancref, setiscancel, durationFreq, isSubscription, orderByObj, isecomDashboard, isSummary, setSelectedRange, selectedRange }) => {
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;

  // console.log(searchItems);
  const [selectedSearch, setSelectedSearch] = useState('');
  useEffect(() => {
    if (isTestOrder) {
      form.setFieldsValue({ searchBy: 'productName', searchTxt: '' });
      form.setFieldsValue({ filterBy: null, filterParam: null });
      setfilterObj({});
      setSelectedSearch('productName');
      setSearchShow({});
      setCurrentPage(1);
    }
  }, [activeIndex, isTestOrder]);
  useEffect(() => {
    if (isTestOrder) {
      if (isFilter && activeIndex == 1) {
        setshowisFilter(false); // Ski API call for Rejected section if no data should be displayed
      }
      if (isFilter && !(activeIndex == 1)) {
        setshowisFilter(true); // Skip API call for Rejected section if no data should be displayed
      }
    }
  }, [activeIndex]);
  const handleFilterByChange = (value) => {
    setfilterObj((prev) => ({ ...prev, filterBy: value }));
  };

  const handleFilterParamChange = (value) => {
    console.log('value', value?.target?.value);
    setfilterObj((prev) => ({ ...prev, filterParam: value?.target?.value }));
  };

  useEffect(() => {
    if (isSubscription) {
      form.setFieldsValue({ searchBy: 'Subscription No', searchTxt: '' });
      form.setFieldsValue({ filterBy: null, filterParam: null });
      // setfilterObj({});
      setSelectedSearch('SubscriptionNo');
      // setSearchShow({});
      setCurrentPage(1);
    }
  }, [activeIndex, isSubscription]);

  useEffect(() => {
    if (isecomDashboard) {
      form.setFieldsValue({ searchBy: 'orderNo', searchTxt: '' });
      // form.setFieldsValue({ searchBy: 'orderNo', searchTxt: null });
      // form.setFieldsValue({ filterBy: null, filterParam: null });
      // setfilterObj({});
      // setSelectedSearch('orderNo');
      // setSearchShow({});
      setCurrentPage(1);
    }
  }, [activeIndex, isecomDashboard]);
  console.log('activeIndexactiveIndex', activeIndex, showisFilter, selectedSearch, durationFreq);
useEffect(() => {
  if(isbarCode){
    console.log("ye chala hai",serialvalue)
  form.setFieldValue('searchTxt',serialvalue);
  }
}, [serialvalue]);
  return (
    <Form
      form={form}
      name='basic'
      initialValues={{
        remember: true,
        ['searchBy']: searchItems[0]?.value,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete='off'
      className='row p-3 pb-0'

    >
      {isSummary ? (
        <div className='col-12 mt-2 col-lg-4 col-md-4'>
          {/* <RangePicker value={searchShow?.dateFrom && searchShow?.dateTo ? selectedRange : null} onChange={onChange} allowClear /> */}

          <RangePicker
            value={selectedRange} // controlled
            onChange={(dates, dateStrings) => {
              setSelectedRange(dates);
              onChange(dates, dateStrings);
            }}
            allowClear
          />
        </div>
      ) : (
        <>
          <div className='col-md-2 col-6'>
            <Form.Item colon={false} name='searchBy' style={{ marginBottom: 0 }}>
              <Select
                style={{ width: '100%', height: '44px', borderRadius: '8px' }}
                onChange={(e) => {
                  isSubscription ? setSelectedSearch(e) : setSelectedSearch(e), form.setFieldsValue({ searchTxt: '' });

                  console.log('ee', e);
                  if (typeof getSearchByValue === 'function') {
                    getSearchByValue(e);
                  }
                  cancref ? setiscancel(false) : '';
                  if (e == 'requestType') {
                    cancref && setiscancel(true);
                  }
                }}
                placeholder='Search By'
              >
                {searchItems.map((item) => (
                  <Select.Option value={item.value}>{item.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className='col-md-2 col-6'>
            {(ecomRequest && selectedSearch === 'requestType') || iscancel ? (
              <Form.Item colon={false} name='searchTxt'>
                <Select placeholder='Request Type'>
                  {[
                    { name: 'Missing Item', value: 'Missing Item' },
                    { name: 'Return and Refund', value: 'Return & Refund' },
                    { name: 'Cancel Order', value: 'Cancel Order' },
                    { name: 'Incomplete Order', value: 'Incomplete Order' },
                    // { name: 'Missing Item', value: 'missing' },
                    // { name: 'Return and Refund', value: 'refund' },
                    // { name: 'Cancel Order', value: 'cancel' },
                    // { name: 'Incomplete Order', value: 'Incomplete' },
                  ].map((item) => (
                    <Select.Option value={item.value}>{item.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            ) : cancref && selectedSearch === 'status' ? (
              <Form.Item colon={false} name='searchTxt'>
                <Select placeholder='Request Type'>
                  {[
                    { name: 'Completed', value: 'complete' },
                    { name: 'Declined', value: 'decline' },

                    // { name: 'Missing Item', value: 'missing' },
                    // { name: 'Return and Refund', value: 'refund' },
                    // { name: 'Cancel Order', value: 'cancel' },
                    // { name: 'Incomplete Order', value: 'Incomplete' },
                  ].map((item) => (
                    <Select.Option value={item.value}>{item.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            ) : selectedSearch === 'duration' ? (
              <Form.Item
                colon={false}
                name='searchTxt'
                // onChange={(e) => {
                //   setSelectedSearch(e), form.setFieldsValue({ searchTxt: '' });
                //   console.log('ee', e);
                //   // cancref ? setiscancel(false) : '';
                //   // if (e == 'requestType') {
                //   //   cancref && setiscancel(true);
                //   // }
                // }}
              >
                <Select
                  placeholder='Duration'
                  onChange={(e) => {
                    console.log('ee', e);
                    // setSelectedSearch(e);
                    // , form.setFieldsValue({ searchTxt: '' });
                  }}
                >
                  {durationFreq?.map((item) => (
                    <Select.Option value={item.name}>{item.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            ) : (
              <Form.Item name='searchTxt' style={{ marginBottom: 0 }}>
                <Input
                  style={{ width: '100%', height: '44px', borderRadius: '8px' }}
                  placeholder={selectedSearch === 'collectionDate' ? 'YYYY-MM-DD' : 'Enter value for search'}
                  onChange={(e) => onChange(e)}
                  type={type}
                  disabled={disabled}
                  ref={inputRef}
                />
              </Form.Item>
            )}
          </div>

          {isFilter && showisFilter && (
            <>
              <div
                className='col-md-5  flex   '
                // style={{marginLeft:'60px'}}
              >
                <div className='col-md-6'>
                  <Form.Item colon={false} name='filterBy'>
                    <Select onChange={handleFilterByChange} placeholder='Filter By'>
                      {[
                        { id: 1, name: 'Accession No', key: 'accessionNo' },
                        // { id: 2, name: 'accessionNo' },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.key}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className='col-md-3 ml-3 '>
                  {/* <Form.Item label='' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
                <Switch
                  checkedChildren='ASC'
                  unCheckedChildren='DESC'
                  // onChange={(e) => {
                  //   console.log(e);
                  //   // setisActiv(e);
                  // }}
                  onChange={handleFilterParamChange}
                />
              </Form.Item> */}
                  <Form.Item label='' className='selector-main pt-1  ' colon={false} name='filterParam'>
                    <Radio.Group onChange={handleFilterParamChange} className='flex'>
                      <Radio value='ASC'>Ascending</Radio>
                      <Radio value='DESC'>Descending</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* <Form.Item colon={false} name='filterParam'>
                <Select placeholder='Filter Param' onChange={handleFilterParamChange}>
                  {[
                    { id: 1, name: 'Descending', key: 'DESC' },
                    { id: 2, name: 'Ascending', key: 'ASC' },
                  ].map((item) => (
                    <Select.Option key={item.id} value={item.key}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}
                </div>
              </div>
              {/* <div className='col-md-1'>
            <Form.Item colon={false}>
              <button type='primary' onClick={}>
                Filter
              </button>
            </Form.Item>
          </div> */}
            </>
          )}

          {isFilter && isSubscription && (
            <>
              <div
                className='col-md-5  flex   '
                // style={{marginLeft:'60px'}}
              >
                <div className='col-md-6'>
                  <Form.Item colon={false} name='filterBy'>
                    <Select onChange={handleFilterByChange} placeholder='Filter By'>
                      {orderByObj.map((item) => (
                        <Select.Option key={item.id} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className='col-md-3 ml-3 '>
                  {/* <Form.Item label='' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
                <Switch
                  checkedChildren='ASC'
                  unCheckedChildren='DESC'
                  // onChange={(e) => {
                  //   console.log(e);
                  //   // setisActiv(e);
                  // }}
                  onChange={handleFilterParamChange}
                />
              </Form.Item> */}
                  <Form.Item label='' className='selector-main pt-1  ' colon={false} name='filterParam'>
                    <Radio.Group onChange={handleFilterParamChange} className='flex'>
                      <Radio value='ASC'>Ascending</Radio>
                      <Radio value='DESC'>Descending</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* <Form.Item colon={false} name='filterParam'>
                <Select placeholder='Filter Param' onChange={handleFilterParamChange}>
                  {[
                    { id: 1, name: 'Descending', key: 'DESC' },
                    { id: 2, name: 'Ascending', key: 'ASC' },
                  ].map((item) => (
                    <Select.Option key={item.id} value={item.key}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}
                </div>
              </div>
              {/* <div className='col-md-1'>
            <Form.Item colon={false}>
              <button type='primary' onClick={}>
                Filter
              </button>
            </Form.Item>
          </div> */}
            </>
          )}
        </>
      )}
      <div
        className='col-md-2 col-12 ml-3'
        style={{
          paddingTop: '0.1rem',
        }}
      >
        <Form.Item colon={false}>
          <button type='primary' className={`btn btn-primary button pl-3 ${isSummary ? 'mt-2' : ''}`} htmlType='submit'>
            Search
          </button>
        </Form.Item>
      </div>
    </Form>
  );
};
 